// extracted by mini-css-extract-plugin
export default {"body":"ShortcutManager__body___KQJgM","footer":"ShortcutManager__footer___kLfHQ","footerVisible":"ShortcutManager__footerVisible___cEEmh"};